const i = (e) => typeof e == "number" ? e : parseFloat(e), l = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9], A = (e) => {
  const s = e.replaceAll(/\s/gi, "");
  let r = e.length, t = 1, c = 0, n;
  for (; r; )
    n = parseInt(s.charAt(--r), 10), c += (t ^= 1) ? l[n] : n;
  return !!(c && c % 10 === 0);
};
var o = /* @__PURE__ */ ((e) => (e.Amex = "amex", e.DinersClub = "dinersclub", e.Discover = "discover", e.JCB = "jcb", e.Mastercard = "mastercard", e.Visa = "visa", e))(o || {});
const u = /^3[47][0-9]{0,}$/, d = /^3[0689][0-9]{0,}[0-9]*$/, m = /^6011[0-9]{0,}[0-9]*$/, g = /^62[24568][0-9]{0,}[0-9]*$/, h = /^6[45][0-9]{0,}[0-9]*$/, b = /^35[0-9]{0,}[0-9]*$/, f = /^5[1-5][0-9]{0,}$/, v = /^2[2-7][0-9]{0,}$/, x = /^4[0-9]{0,}(?:[0-9]{3})?$/, L = (e) => {
  const s = e.replaceAll(/\s/gi, "");
  if (x.test(s))
    return "visa";
  if (u.test(s))
    return "amex";
  if (f.test(s) || v.test(s))
    return "mastercard";
  if (m.test(s) || g.test(s) || h.test(s))
    return "discover";
  if (d.test(s))
    return "dinersclub";
  if (b.test(s))
    return "jcb";
};
var p = /* @__PURE__ */ ((e) => (e.XSmall = "xs", e.Small = "sm", e.Medium = "md", e.Large = "lg", e.XLarge = "xl", e.XXLarge = "2xl", e))(p || {});
const a = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  ["2xl"]: 1536
}, $ = Object.keys(a), j = Object.values(a), k = (e, s) => {
  const r = e.length;
  for (let t = r - 1; t >= 0; t -= 1)
    if (i(e[t]) <= s)
      return t;
  return -1;
}, E = (e) => $[k(j, e)], N = {
  async: !0
}, X = (e, s = {}) => {
  const r = document.createElement("script");
  return Object.keys(s).forEach((t) => {
    r[t] = s[t] || N[s];
  }), r.src = e, [
    r,
    () => {
      var c;
      const t = document.getElementsByTagName("script")[0];
      return (c = t == null ? void 0 : t.parentNode) == null || c.insertBefore(r, t), r;
    }
  ];
}, w = (e) => {
  let s = [], r = !1;
  return [
    (...t) => {
      if (!r) {
        s.push(t);
        return;
      }
      e(...t);
    },
    () => {
      r || (s.forEach(async (t) => {
        await e(...t);
      }), s = [], r = !0);
    }
  ];
};
var T = /* @__PURE__ */ ((e) => (e.Highlight = "highlight", e.Critical = "critical", e.Warning = "warning", e.Success = "success", e.Light = "light", e.Dark = "dark", e))(T || {});
export {
  p as B,
  o as C,
  T as S,
  i as a,
  E as b,
  a as c,
  $ as d,
  j as e,
  k as g,
  X as i,
  A as l,
  w as m,
  L as t
};
//# sourceMappingURL=state.e6e166b2.js.map
